<div class="modal-header">
  <h4 class="modal-title">Gift Center Preview</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <small class="form-text text-muted mt-0 mb-3">
    This preview shows your current settings, including unsaved changes. Images show what is saved. Links open the live page in a new tab.
  </small>

  <div class="btn-group mb-3" role="group" aria-label="Preview page">
    <button type="button" class="btn btn-outline-primary"
            [class.active]="activePage === 'home'"
            [attr.aria-pressed]="activePage === 'home'"
            (click)="showPage('home')">
      Home Page
    </button>
    <button type="button" class="btn btn-outline-primary"
            [class.active]="activePage === 'give'"
            [attr.aria-pressed]="activePage === 'give'"
            (click)="showPage('give')">
      Give a Gift
    </button>
  </div>

  <p *ngIf="loadingPreview">Loading preview...</p>

  <iframe #previewFrame
          title="Gift Center preview"
          style="width: 100%; border: 0;"></iframe>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="activeModal.close()">
    Close
  </button>
</div>
